import { Link } from 'react-router-dom';

export default function Hero() {
  const scrollToPicks = () => {
    const el = document.getElementById('editors-picks');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <section className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden md:h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20anime%20manga%20illustration%20collage%20of%20floating%20books%20and%20glowing%20comic%20panels%20with%20silhouettes%20of%20characters%2C%20warm%20orange%20amber%20and%20coral%20color%20palette%2C%20dreamy%20atmospheric%20light%2C%20dark%20moody%20background%20with%20soft%20bokeh%2C%20artistic%20digital%20illustration&width=1600&height=1000&seq=hero-manga-island&orientation=landscape"
        alt="漫画岛发现好漫"
        title="漫画岛 - 发现好漫频道"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/45 to-background-950/75"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-background-950/40 px-4 py-1.5 text-sm font-medium text-accent-200 backdrop-blur">
          <i className="ri-sparkling-2-fill text-base"></i>
          漫画岛编辑精选 · 每日推荐
        </span>
        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          发现好漫，<span className="text-accent-300">追更从此有方向</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
          漫画岛发现好漫频道，编辑精选每日推荐热门新作与潜力佳作。想找下一部入坑作品，来漫画岛探索推荐，挖掘好货不踩雷。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/category/reXue"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-compass-3-line text-lg"></i>
            开始发现好漫
          </Link>
          <button
            type="button"
            onClick={scrollToPicks}
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3.5 text-base font-bold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            <i className="ri-fire-line text-lg"></i>
            查看编辑精选
          </button>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-background-50/80">
        <i className="ri-arrow-down-s-line animate-bounce text-3xl"></i>
      </div>
    </section>
  );
}